<template>
    <Multiselect
        ref="Multiselect"
        :initial-value="$attrs['initial-value'] || innerInitialValue"
        :options="options"
        :loading="loading"
        :placeholder="$t('campaigns')"
        :selected-options-label="$t('selectedCampaigns')"
        searchable
        group-label="group"
        group-values="campaigns"
        track-by="id"
        label="name"
        select-label=""
        show-checkboxes
        show-selected
        multiple
        :close-on-select="false"
        :clear-on-select="false"
        class="width-200"
        group-select
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>



<script>
    import differenceBy from 'lodash/differenceBy';
    import sortBy from 'lodash/sortBy';
    import Multiselect from '@/components/common/Multiselect.vue';

    export default {
        name: 'MultiselectAvailableCampaigns',
        components: {
            Multiselect,
        },
        data() {
            return {
                requestActiveCampaigns: this.$req('buyboxes/ActiveCampaigns'),
                requestAvailableCampaigns: this.$req('buyboxes/AvailableCampaigns'),
                innerInitialValue: undefined,
            };
        },
        computed: {
            loadingProducerPlugin() {
                return this.$store.getters['plugin/getLoadingProducerPlugin'];
            },
            loading() {
                return this.loadingProducerPlugin || this.requestAvailableCampaigns.getLoading() || this.requestActiveCampaigns.getLoading();
            },
            activeCampaigns() {
                return sortBy(this.requestActiveCampaigns.getData() || [], 'name');
            },
            availableCampaigns() {
                return sortBy(this.requestAvailableCampaigns.getData() || [], 'name');
            },
            otherCampaigns() {
                return differenceBy(this.availableCampaigns, this.activeCampaigns, 'id');
            },
            options() {
                return [
                    {
                        group: this.$t('optionsActiveCampaignsLabel'),
                        campaigns: this.activeCampaigns,
                    },
                    {
                        group: this.$t('optionsOtherCampaignsLabel'),
                        campaigns: this.otherCampaigns,
                    },
                ];
            },
        },
        watch: {
            loadingProducerPlugin: {
                immediate: true,
                handler(pluginLoading) {
                    if (!pluginLoading) this.fetchCampaigns();
                },
            },
            loading: {
                immediate: true,
                handler() {
                    if (!this.loading && !this.innerInitialValue && this.activeCampaigns.length) {
                        this.innerInitialValue = this.activeCampaigns?.map(item => item.id);
                        this.$nextTick(() => {
                            this.$refs.Multiselect.emitChange();
                            this.$emit('loading', this.loading);
                        });
                    } else {
                        this.$emit('loading', this.loading);
                    }
                },
            },
        },
        methods: {
            fetchCampaigns() {
                const id = this.$store.getters['plugin/getProducerPlugin'].id;
                this.requestAvailableCampaigns.get({ urlParams: { id } });
                this.requestActiveCampaigns.get({ urlParams: { id } });
            },
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "optionsActiveCampaignsLabel": "Wyświetlane w pluginie",
    "optionsOtherCampaignsLabel": "Pozostałe sklepy"
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "optionsActiveCampaignsLabel": "Displayed in plugin",
    "optionsOtherCampaignsLabel": "Other campaigns"
}
</i18n>
